/* eslint-disable react-hooks/exhaustive-deps */
import { useDispatch, useSelector } from "react-redux";
import { selectEditMode } from "../../slices/editMode/editModeSlice";
import { selectResourceById } from "../../slices/resourceCollection/resourceCollectionSlice";
import Spinner from "../../components/Spinner";
import { changeBrowserTabTitle } from "../../slices/browserTabTitle/browserTabTitleSlice";
import { changeTool } from "../../slices/footer/footerSlice";
import SummaryOfNetEffectDisplay from "./SummaryOfNetEffectDisplay";
import SummaryOfFindingsDisplay from "./SummaryOfFindingsDisplay";
import MappedEvidenceReportDisplay from "./MappedEvidenceReportDisplay";
import CompositionBasicDisplay from "./CompositionBasicDisplay";
import { useEffect, useState } from "react";
import getIdFromReference from "../../functions/getIdFromReference";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import getFhirJson from "../../functions/getFhirJsonAPI";
import { fetchRelatedResourceCollection } from "../../slices/relatedResourceCollection/relatedResourceCollectionSlice";

const loadTheRelatedFhirJson = async (FOI, apiToken, dispatch, setTriggerReload) => {
    let fhirJson = await getFhirJson(FOI, null, apiToken, false);
    if (fhirJson && typeof fhirJson === "object") {
        const resourceType = fhirJson.resourceType;
        let productFamily = resourceType;
        if (resourceType === "Composition") {
            productFamily = fhirJson.type?.coding?.[0]?.code || fhirJson.type?.text || "Composition";
        }
        let body = {
            parentProductFoi: fhirJson.id, productFamily: productFamily,
            resourceType: resourceType, fhirJson: fhirJson
        };
        dispatch(fetchRelatedResourceCollection(body));
        setTriggerReload(true);
    } else {
        alert("No Resource found for FOI:" + FOI);
    }
};

const CompositionCoreDisplay = ({ foi }) => {

    const dispatch = useDispatch();
    const editMode = useSelector(state => selectEditMode(state));
    const apiToken = useSelector(selectCurrentUserApiToken);
    const parentResourceDetail = useSelector(state => selectResourceById(state, foi));
    const resourceJson = parentResourceDetail?.revisedResourceJson;
    const displayTitle = parentResourceDetail?.displayTitle;

    let isEvidenceReportProfile;
    let isResearchStudyDataDictionaryProfile;
    let isEvidenceReportPackageProfile;
    let isComparativeEvidenceReportProfile;
    let isComparativeEvidenceSynthesisReportProfile;
    let isBaselineMeasureReportProfile;
    let isParticipantFlowReportProfile;
    let isOutcomeMeasureReportProfile;
    let isSummaryOfFindingsProfile;
    let isGuidelineProfile;
    let isGuidelineRegistryRecordProfile;
    let isRecommendationProfile;
    let isSummaryOfNetEffectProfile;
    let isM11ReportProfile;
    if (resourceJson.meta?.profile?.length) {
        for (const profile of resourceJson.meta.profile) {
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report") {
                isEvidenceReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/baseline-measure-report") {
                isEvidenceReportProfile = true;
                isBaselineMeasureReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/outcome-measure-report" ||
                profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/adverse-events-report"
            ) {
                isEvidenceReportProfile = true;
                isOutcomeMeasureReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/participant-flow-report") {
                isEvidenceReportProfile = true;
                isParticipantFlowReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/research-study-data-dictionary") {
                isEvidenceReportProfile = true;
                isResearchStudyDataDictionaryProfile = true;
            }
            if (profile.includes("http://hl7.org/fhir/uv/ebm/StructureDefinition/m11-report")) {
                isEvidenceReportProfile = true;
                isM11ReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/summary-of-findings") {
                isEvidenceReportProfile = true;
                isSummaryOfFindingsProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/evidence-report-package") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence-report" ||
                profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence-report-expanded"
            ) {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isComparativeEvidenceReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/comparative-evidence-synthesis-report") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isComparativeEvidenceSynthesisReportProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isGuidelineProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/guideline-registry-record") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isGuidelineProfile = true;
                isGuidelineRegistryRecordProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/recommendation") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isRecommendationProfile = true;
            }
            if (profile === "http://hl7.org/fhir/uv/ebm/StructureDefinition/summary-of-net-effect") {
                isEvidenceReportProfile = true;
                isEvidenceReportPackageProfile = true;
                isSummaryOfNetEffectProfile = true;
            }
        }
    }
    let toolDisplayName = "Composition";
    if (isEvidenceReportProfile) { toolDisplayName = "EvidenceReport"; }
    if (isEvidenceReportPackageProfile) { toolDisplayName = "EvidenceReport"; }
    if (isResearchStudyDataDictionaryProfile) { toolDisplayName = "Research Study Data Dictionary"; }
    if (isComparativeEvidenceReportProfile) { toolDisplayName = "Comparative Evidence Report"; }
    if (isComparativeEvidenceSynthesisReportProfile) { toolDisplayName = "Comparative Evidence Synthesis Report"; }
    if (isBaselineMeasureReportProfile) { toolDisplayName = "Baseline Measure Report"; }
    if (isParticipantFlowReportProfile) { toolDisplayName = "Participant Flow Report"; }
    if (isOutcomeMeasureReportProfile) { toolDisplayName = "Outcome Measure Report"; }
    if (isSummaryOfFindingsProfile) { toolDisplayName = "Summary of Findings"; }
    if (isGuidelineProfile) { toolDisplayName = "Guideline"; }
    if (isGuidelineRegistryRecordProfile) { toolDisplayName = "Guideline Registry Record"; }
    if (isRecommendationProfile) { toolDisplayName = "Recommendation"; }
    if (isSummaryOfNetEffectProfile) { toolDisplayName = "Summary of Net Effect"; }
    if (isM11ReportProfile) { toolDisplayName = "M11 Report"; }

    const [relatedReportState, setRelatedReportState] = useState({ "relatedOutcomeMeasureReportFoi": "" });
    const [triggerReload, setTriggerReload] = useState(false);

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR " + toolDisplayName + " - " + displayTitle));
        if (isComparativeEvidenceReportProfile || isComparativeEvidenceSynthesisReportProfile) {
            let relatedOutcomeMeasureReportFoi = "";
            if (resourceJson.section?.length > 0) {
                for (const section of resourceJson.section) {
                    if (section?.code?.coding?.[0]?.code === "outcome-findings" || 
                        section?.code?.coding?.[0]?.code === "outcome-measures" ||
                        section?.code?.coding?.[0]?.code === "results"
                    ) {
                        if (section.entry?.length) {
                            for (const entry of section.entry) {
                                if (entry.type === "Composition") {
                                    relatedOutcomeMeasureReportFoi = getIdFromReference(entry);
                                }
                            }
                        }
                    }
                }
            }
            setRelatedReportState({ "relatedOutcomeMeasureReportFoi": relatedOutcomeMeasureReportFoi });
        }
    }, []);

    useEffect(() => {
        dispatch(changeTool("Computable Publishing®: " + toolDisplayName + " " + (editMode ? "Authoring Tool" : "Viewing Tool")));
    }, [editMode, toolDisplayName]);

    useEffect(() => {
        if (relatedReportState.relatedOutcomeMeasureReportFoi) {
            loadTheRelatedFhirJson(relatedReportState.relatedOutcomeMeasureReportFoi, apiToken, dispatch, setTriggerReload);
        }
    }, [relatedReportState]);

    if (!resourceJson) {
        return <Spinner />;
    }

    if (isSummaryOfNetEffectProfile) {
        return <SummaryOfNetEffectDisplay foi={foi} />
    }

    if (isSummaryOfFindingsProfile) {
        return <SummaryOfFindingsDisplay foi={foi} />
    }

    if (isComparativeEvidenceReportProfile || isComparativeEvidenceSynthesisReportProfile ||
        isBaselineMeasureReportProfile || isParticipantFlowReportProfile || isOutcomeMeasureReportProfile) {
        return <MappedEvidenceReportDisplay foi={foi}
            relatedOutcomeMeasureReportFoi={relatedReportState.relatedOutcomeMeasureReportFoi}
            triggerReload={triggerReload} setTriggerReload={setTriggerReload} />
    }

    return <CompositionBasicDisplay foi={foi} />

}

export default CompositionCoreDisplay;